// Kleine DOM-helpers, geport uit het prototype. Tekst gaat altijd via textContent.

type AttrValue = string | number | boolean | null | undefined | ((event: Event) => void);
export type Attrs = Record<string, AttrValue>;
export type Child = Node | string | null | undefined | false;

const TOAST_MS = 3200;

const eurWhole = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const eurCents = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });

/** Bedrag in gehele centen als "€ 12,50", of "€ 12" bij een rond bedrag. */
export function formatEuro(cents: number): string {
  return cents % 100 === 0 ? eurWhole.format(cents / 100) : eurCents.format(cents / 100);
}

export function $(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Element #${id} ontbreekt`);
  return el;
}

function toNode(child: string | Node): Node {
  return typeof child === 'string' ? document.createTextNode(child) : child;
}

function setAttr(el: HTMLElement, key: string, value: AttrValue): void {
  if (value === null || value === undefined || value === false) return;
  if (key === 'style') throw new Error('Gebruik een CSS-klasse in plaats van een style-attribuut (CSP)');
  if (key === 'text') el.textContent = String(value);
  else if (key === 'class') el.className = String(value);
  else if (key.startsWith('on') && typeof value === 'function') el.addEventListener(key.slice(2), value);
  else if (typeof value !== 'function') el.setAttribute(key, value === true ? '' : String(value));
}

export function add<T extends Node>(el: T, ...children: (Child | Child[])[]): T {
  for (const c of children) {
    if (Array.isArray(c)) add(el, ...c);
    else if (c !== null && c !== undefined && c !== false) el.appendChild(toNode(c));
  }
  return el;
}

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs?: Attrs | null,
  ...children: (Child | Child[])[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (attrs) for (const [k, v] of Object.entries(attrs)) setAttr(el, k, v);
  return add(el, ...children);
}

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function toast(msg: string): void {
  const t = $('toast');
  t.textContent = msg;
  t.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    t.hidden = true;
  }, TOAST_MS);
}

// ---- dialoog: één <dialog> waarvan de inhoud telkens vervangen wordt ----

function dialog(): HTMLDialogElement {
  return $('dlg') as HTMLDialogElement;
}

export function showDialog(content: HTMLElement): void {
  const dlg = dialog();
  content.id = 'dlgBody';
  $('dlgBody').replaceWith(content);
  if (!dlg.open) dlg.showModal();
}

export function closeDialog(): void {
  const dlg = dialog();
  if (dlg.open) dlg.close();
}

export function initDialog(): void {
  const dlg = dialog();
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) closeDialog();
  });
}

/** Bedrag in centen als tekst voor een invoerveld: "50" of "12,50". */
export function centsToInput(cents: number): string {
  const euros = Math.trunc(cents / 100);
  const rest = cents % 100;
  return rest === 0 ? String(euros) : `${euros},${String(rest).padStart(2, '0')}`;
}
